import { combineReducers } from "redux"
import * as t from "./actionTypes"
import * as feedbackTypes from "../feedback/actionTypes"
import {
  SET_ITEM_TEXT,
  SET_CACHED_HEADER,
  SET_ITEM_FINISHED,
} from "../search/actionTypes"
import { setterReducer } from "../common/redux"

const stashedResponse = setterReducer([], t.SET_STASHED_RESPONSE)
const interviewStarted = setterReducer(null, t.SET_INTERVIEW_STARTED)
const cachedQuestion = setterReducer(null, t.SET_CACHED_QUESTION)
const filterError = setterReducer("", t.SET_FILTER_ERROR)
const responseHeight = setterReducer(0, t.SET_RESPONSE_HEIGHT)

const active = (state = -1, action) => {
  switch (action.type) {
    case t.UPDATE_ACTIVE_INDEX:
      return action.index
    case t.ADD_CHAT_ITEM:
      return state + 1
    case t.SET_CHAT_ITEMS:
      return action.payload.length - 1
    default:
      return state
  }
}

const updateItem = (state, f, index) =>
  state.map(item => (item.index === index ? { ...item, ...f(item) } : item))

const items = (state = [], action) => {
  switch (action.type) {
    case t.ADD_CHAT_ITEM:
      let item = { index: state.length, ...action.item }
      return [...state, item]
    case t.DELETE_CHAT_ITEMS:
      return state.filter(item => item.index <= action.index)
    case t.SET_RESPONSE:
      return updateItem(
        state,
        item => ({ response: action.response }),
        action.index
      )
    case t.ADD_RESPONSE:
      return updateItem(
        state,
        item => ({
          response: [
            ...item.response.filter(x => !x.isskip && !x.isnota),
            action.response,
          ],
        }),
        action.index
      )
    case t.REMOVE_RESPONSE:
      return updateItem(
        state,
        item => ({
          response: item.response.filter(
            x => x.token !== action.response.token
          ),
        }),
        action.index
      )
    case t.SET_DURATION_AMOUNT:
      return updateItem(
        state,
        item => ({
          duration: { ...item.duration, amount: action.amount },
        }),
        action.index
      )
    case t.SET_DURATION_UNIT:
      return updateItem(
        state,
        item => ({
          duration: { ...item.duration, unit: action.unit },
        }),
        action.index
      )
    case SET_ITEM_TEXT:
      return updateItem(
        state,
        item => ({
          text: action.text,
        }),
        action.index
      )
    case SET_CACHED_HEADER:
      return updateItem(
        state,
        item => ({
          cachedHeader: { ...action.cachedHeader },
        }),
        action.index
      )
    case SET_ITEM_FINISHED:
      return updateItem(
        state,
        item => ({
          finished: action.finished,
        }),
        action.index
      )
    case t.SET_FREE_TEXT:
      return updateItem(
        state,
        item => ({
          options: item.options.map(o => {
            if (
              o.isfreetext &&
              item.response.filter(x => x.token === o.token).length
            ) {
              return { ...o, freetext: action.text }
            }
            return o
          }),
        }),
        action.index
      )
    case t.SET_DIAGNOSES:
      return updateItem(
        state,
        item => ({ dgn: action.diagnoses }),
        action.index
      )
    case t.SET_PRED_INFO:
      return updateItem(
        state,
        item => ({ predInfoLists: action.predInfo }),
        action.index
      )
    case t.SET_RESOURCE:
      return updateItem(
        state,
        item => ({ resource: action.resource }),
        action.index
      )
    case t.SET_CHAT_ITEMS:
      return action.payload.map((x, i) => ({ index: i, ...x }))
    case feedbackTypes.FLAG_ITEM:
      return updateItem(state, item => ({ flagged: true }), action.index)
    case feedbackTypes.UNFLAG_ITEM:
      return updateItem(state, item => ({ flagged: false }), action.index)
    case t.SET_ITEM_BLUR:
      return updateItem(
        state,
        item => ({
          blur: action.blur,
        }),
        action.index
      )
    default:
      return state
  }
}

const chatList = combineReducers({
  active,
  items,
  stashedResponse,
  interviewStarted,
  cachedQuestion,
  filterError,
  responseHeight,
})

const chatListWrapper = (state, action) => {
  //Autopopulate with active for item updating
  if (state && action.index === undefined) action.index = state.active
  return chatList(state, action)
}

export { chatListWrapper as default }



// WEBPACK FOOTER //
// ./assets/interview/chatList.js